import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import Layout from '../component/layout'
import { getItem } from '../../../utils/localStorage';
import { getFacilityUnits } from '../../../utils/urls';
import { makeRequest2 } from '../../../utils/makeRequest';
import { toastify } from '../../../utils/toast';
import { Dialog } from 'primereact/dialog';

function Dashboard() {
  const navigate = useNavigate();
  const [occupiedUnits, setOccupiedUnits] = useState(0);
  const [notOccupiedUnits, setUnoccupiedUnits] = useState(0);
  const [occupiedUnitData, setOccupiedUnitData] = useState([]);
  const [unoccupiedUnitData, setUnoccupiedUnitData] = useState([]);
  const [modalTitle, setModalTitle] = useState("Units");
  const [unitListModalOpen, setUnitListModalOpen] = useState(false);
  const [unitList, setUnitList] = useState([]);

  const fetchUnitsCount = async () => {
    try {
      const facilityId = await getItem('selectedFacilityId')
      const response = await makeRequest2(`${getFacilityUnits}/${facilityId}`, 'GET', {});

      if (response.success) {
        const { occupiedUnits, notOccupiedUnits } = response.data;
        setOccupiedUnits(occupiedUnits.length);
        setUnoccupiedUnits(notOccupiedUnits.length);
        setOccupiedUnitData(occupiedUnits);
        setUnoccupiedUnitData(notOccupiedUnits);
      } else {
        throw new Error('Failed to fetch units count');
      }
    } catch (err) {
      console.error(err.message);
      toastify(err.message, 'error');
    }
  };
  const handleViewUnits = (type) => {
    if (type === "occupied") {
      setModalTitle("Occupied Units");
      setUnitList(occupiedUnitData);
    }
    else {
      setModalTitle("Unoccupied Units");
      setUnitList(unoccupiedUnitData);
    }
    setUnitListModalOpen(true);
  };

  useEffect(() => {
    fetchUnitsCount();
  }, []);

  return (
    <Layout>
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header">
              <div className="flex-grow-1 ms-3">
                <h6 className="mb-0">Units</h6>
              </div>
            </div>
            <div className="card-body">

              <div className="row mt-3">
                <div className="col-md-6 col-xxl-6">
                  <div className="card">
                    <div className="card-body">
                      <div className="row align-items-center">
                        <div className="col-8" onClick={() => handleViewUnits("occupied")} style={{ cursor: "pointer" }}>
                          <h3 className="mb-1">{occupiedUnits}</h3>
                          <p className="text-muted mb-0">Occupied Units</p>
                        </div>
                        <div className="col-4 text-end">
                          <i className="ti ti-lock text-primary f-36"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-xxl-6">
                  <div className="card">
                    <div className="card-body">
                      <div className="row align-items-center">
                        <div className="col-8" onClick={() => handleViewUnits("unoccupied")} style={{ cursor: "pointer" }}>
                          <h3 className="mb-1">{notOccupiedUnits}</h3>
                          <p className="text-muted mb-0">Unoccupied Units</p>
                        </div>
                        <div className="col-4 text-end">
                          <i className="ti ti-lock-open text-danger f-36"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Dialog
        header={modalTitle}
        visible={unitListModalOpen}
        style={{ width: '80vw', maxWidth: '900px' }}
        modal
        className="p-fluid"
        onHide={() => setUnitListModalOpen(false)}
      >
        <div className="container py-3">
          {unitList.map((unit) => (
            <div key={unit._id} className="col-12">
              <div className="card shadow-sm p-3 hover-shadow">
                <div className="d-flex justify-content-between align-items-center">
                  <h5
                    className="card-title mb-0 text-primary"
                    style={{ cursor: "pointer", textDecoration: "none" }}
                    onClick={() => {
                      setUnitListModalOpen(false);
                      navigate(`/facility/unit_management/view_unit/${unit._id}`);
                    }}
                  >
                    {unit.name}
                  </h5>
                  <span className="badge bg-secondary">{unit.unitType}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Dialog>

    </Layout>

  )
}
export default Dashboard